import React from 'react';
import Button from '../Button';
import style from './TransparentButton.module.css'
const TransparentButton = ({title,disabled,onClick}) => {
    return (
        <div className={style['transaction-button-box']}>
            <Button title={title} onClick={onClick} disabled={disabled}></Button>
        </div>
    );
};
export default TransparentButton;